export default function PlusIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M3.05225 10.0068C3.05225 9.75228 3.14355 9.53369 3.32617 9.35107C3.50879 9.16292 3.72738 9.06885 3.98193 9.06885H9.07031V3.98877C9.07031 3.73421 9.16162 3.51562 9.34424 3.33301C9.52686 3.15039 9.74544 3.05908 10 3.05908C10.2601 3.05908 10.4814 3.15039 10.6641 3.33301C10.8467 3.51562 10.938 3.73421 10.938 3.98877V9.06885H16.0181C16.2726 9.06885 16.4912 9.16292 16.6738 9.35107C16.8564 9.53369 16.9478 9.75228 16.9478 10.0068C16.9478 10.2669 16.8564 10.4883 16.6738 10.6709C16.4912 10.848 16.2726 10.9365 16.0181 10.9365H10.938V16.0332C10.938 16.2822 10.8467 16.498 10.6641 16.6807C10.4814 16.8633 10.2601 16.9546 10 16.9546C9.74544 16.9546 9.52686 16.8633 9.34424 16.6807C9.16162 16.498 9.07031 16.2822 9.07031 16.0332V10.9365H3.98193C3.72738 10.9365 3.50879 10.848 3.32617 10.6709C3.14355 10.4883 3.05225 10.2669 3.05225 10.0068Z" />
    </svg>
  );
}
